/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import _ from 'lodash';
import {Ng2StateDeclaration} from '@uirouter/angular';
import {AdminResourceItemRoutePageComponent} from '../common/controller/admin-resource-item-route-page.component';
import {AdminResourceContextRoutePageComponent} from '../common/controller/admin-resource-context-route-page.component';
import {getRoutePageComponent, getContextRoutePageComponent} from '../common/controller/route-page-component-registry';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {adminResourceItemRouteResolve} from '../common/controller/admin-resource-routing';
import {InvoiceTranslationResource} from '../../components/api/resources/resource/invoice-translation.resource';
export function invoiceTranslationStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterHelper('invoice-translations.invoice-translation', InvoiceTranslationResource, 'app.rep', 'app');
    
        $stateProvider.state(rh.listPath(), rh.list({
          views: {
            'content@app': { component: getRoutePageComponent('invoice-translation-route') }
          }
        }));
    
        $stateProvider.state(rh.newItemPath(), rh.newItem());
    
        $stateProvider.state(rh.itemPath(), rh.modelCommsItem({
          resolve: _.merge({}, adminResourceItemRouteResolve('invoice-translation-edit', 'edit')),
            views: {
            'content@app': { component: AdminResourceItemRoutePageComponent, bindings: { item: 'adminResourceItemKey', variant: 'adminResourceItemVariant' }  },
            'context@app': {component: AdminResourceContextRoutePageComponent}
          }
        }, 'InvoiceTranslation'));
  }, adnRouterHelper);
}
